import { invert } from 'lodash';
import { Quotation } from './quotation';

export const SourceSite = {
  DEM: 'DEM',
  P2U: 'P2U',
  ESP: 'ESP',
  HHP: 'HHP',
  DHSN: 'DHSN',
} as const;

export const RequestType = {
  PRESCRIPTION: 'PRESCRIPTION',
} as const;

export const Status = {
  OPEN: 'OPEN',
  COMPLETED: 'COMPLETED',
  CLOSED: 'CLOSED',
} as const;
export const InvertedSourceSite = invert(SourceSite);
export const InvertedRequestType = invert(RequestType);
export const InvertedStatus = invert(Status);

export type SourceSiteType = typeof SourceSite[keyof typeof SourceSite];
export type StatusType = typeof Status[keyof typeof Status];
export type RequestTypeType = typeof RequestType[keyof typeof RequestType];

export interface QuotationRequest {
  _id?: string;
  code?: string;
  requestedTo?: string;

  requestedBy?: string;
  requestedByData?: any; // profile or org

  files: any[];
  files_data: any[];
  sourceSite: SourceSiteType;
  requestType: RequestTypeType;
  status: StatusType;

  quotations?: Quotation[];

  createdBy?: string;
  createdAt?: string;
  updatedBy?: string;
  updatedAt?: string;
}
